import axios from "../../../../axios";
import Cookies from "js-cookie";

// Harshada Bhavsar(4/7/2025)
// Create consultant API call
export const createConsultant = async (formData) => {
  const token = Cookies.get("employeeToken");

  if (!token) {
    throw new Error("Login token missing.");
  }

  const payload = {
    token,
    ...formData,
  };

  return axios.post("/api/Admin/Employee/CreateConsultant", payload);
};

// Harshada Bhavsar(19/01/2026)
// bulk Create consultant API call
export const bulkCreateConsultant = async (file) => {
  const token = Cookies.get("employeeToken");

  if (!token) {
    throw new Error("Login token missing.");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("token", token);

  return axios.post(
    "/api/Admin/Employee/BulkCreateConsultant",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
